import { CurrentUserResponseDto } from '@common/models/current-user/current-user.dto';
import { CurrentUserVm } from '@common/models/current-user/current-user.vm';
import { CurrentPersonMapper } from './current-person.mapper';

export class CurrentUserMapper {
  static mapResponseToVm(response: CurrentUserResponseDto): CurrentUserVm {
    return {
      uuid: response.uuid,
      username: response.usuario,
      roleUuid: response.id_rol,
      imageUrl: response.imagen,
      aprobation: response.aprobacion,
      person: CurrentPersonMapper.mapResponseToVm(response.persona),
    };
  }
}
